import { formatISOToDisplayDate } from '@/lib/utils';
import {
    isValid, parseISO, isSameDay
} from 'date-fns';

export const dateFilter = (
    row: { getValue: (columnId: string) => unknown },
    columnId: string,
    filterValue: string
) => {
    const rawCellValue = row.getValue(columnId);
    if (typeof rawCellValue !== 'string') return false;

    const cellDate = parseISO(rawCellValue);
    const filterDate = parseISO(filterValue);

    if (!isValid(cellDate) || !isValid(filterDate)) return false;

    return isSameDay(cellDate, filterDate);
};

export const dateRangeFilter = (
    row: { getValue: (columnId: string) => unknown },
    columnId: string,
    filterValue: { from?: string; to?: string }
) => {
    if (!filterValue || (!filterValue.from && !filterValue.to)) return true;

    const rawValue = row.getValue(columnId);
    if (typeof rawValue !== 'string') return false;

    const cellDate = parseISO(rawValue);
    if (!isValid(cellDate)) return false;

    const fromDate = filterValue.from ? parseISO(filterValue.from) : null;
    const toDate = filterValue.to ? parseISO(filterValue.to) : null;

    if (fromDate && !isValid(fromDate)) return false;
    if (toDate && !isValid(toDate)) return false;

    if (fromDate && toDate) {
        return cellDate >= fromDate && cellDate <= toDate;
    } else if (fromDate) {
        return cellDate >= fromDate;
    } else if (toDate) {
        return cellDate <= toDate;
    }

    return true;
};

export const dateOrStringFilter = (
    row: { getValue: (columnId: string) => unknown },
    columnId: string,
    filterValue: string
) => {
    const rawCellValue = row.getValue(columnId);
    const cellString = typeof rawCellValue === 'string' ? rawCellValue : '';

    const cellDate = parseISO(cellString);

    if (isValid(cellDate)) {
        const formattedCellDate = formatISOToDisplayDate(cellString);

        return formattedCellDate.includes(filterValue);
    }

    // If cellDate not valid, fallback to string includes on raw value
    return cellString.toLowerCase().includes(filterValue.toLowerCase());
};
